export default {
  data: function data() {
    return {};
  },
  mounted: function mounted() {},
  methods: {}
};